__turbopack_context__.v({
  "acheiverrank": "infrastructure-module__lZtkNG__acheiverrank",
  "active": "infrastructure-module__lZtkNG__active",
  "bottom-left": "infrastructure-module__lZtkNG__bottom-left",
  "close": "infrastructure-module__lZtkNG__close",
  "gallery_img_modal": "infrastructure-module__lZtkNG__gallery_img_modal",
  "gallerymodal": "infrastructure-module__lZtkNG__gallerymodal",
  "imagee": "infrastructure-module__lZtkNG__imagee",
  "imgstyle": "infrastructure-module__lZtkNG__imgstyle",
  "modal-open": "infrastructure-module__lZtkNG__modal-open",
  "modalcontent": "infrastructure-module__lZtkNG__modalcontent",
  "modaldialog": "infrastructure-module__lZtkNG__modaldialog",
  "nav-item": "infrastructure-module__lZtkNG__nav-item",
  "nav-link": "infrastructure-module__lZtkNG__nav-link",
  "nav-pills": "infrastructure-module__lZtkNG__nav-pills",
  "nav-tabs": "infrastructure-module__lZtkNG__nav-tabs",
  "next": "infrastructure-module__lZtkNG__next",
  "pagemaintitle": "infrastructure-module__lZtkNG__pagemaintitle",
  "playbutton": "infrastructure-module__lZtkNG__playbutton",
  "playwrap": "infrastructure-module__lZtkNG__playwrap",
  "prev": "infrastructure-module__lZtkNG__prev",
  "sectiontitle": "infrastructure-module__lZtkNG__sectiontitle",
  "show": "infrastructure-module__lZtkNG__show",
  "tabactive": "infrastructure-module__lZtkNG__tabactive",
  "tablinks": "infrastructure-module__lZtkNG__tablinks",
  "tabscrollclass": "infrastructure-module__lZtkNG__tabscrollclass",
  "tabsection": "infrastructure-module__lZtkNG__tabsection",
  "trigger_popup_fricc": "infrastructure-module__lZtkNG__trigger_popup_fricc",
  "whole_div_gallery": "infrastructure-module__lZtkNG__whole_div_gallery",
  "zoom": "infrastructure-module__lZtkNG__zoom",
});
